import React from 'react';
import { render } from 'react-dom';
import angular from 'angular';
import { withProviders } from '../../../core/components';
import { ClosedCaptions } from './closed-captions';
import { localeService } from '../../../core/';
export default angular
    .module('doxy.call.closed-captions', [])
    .component('closedCaptions', {
    template: '<div></div>',
    bindings: {
        captions: '<',
        onClose: '&',
    },
    controller: function ($element) {
        const translatedText = {
            closeText: localeService.formatMessageById('closedCaptions.closeText'),
            returnText: localeService.formatMessageById('closedCaptions.returnText'),
            waitingText: localeService.formatMessageById('closedCaptions.waitingText'),
        };
        const ClosedCaptionsWithProviders = withProviders(({ onClose }) => (<ClosedCaptions onClose={onClose} translatedText={translatedText}/>));
        this.$onInit = () => {
            render(<ClosedCaptionsWithProviders onClose={() => this.onClose?.()} translatedText={translatedText}/>, $element[0]);
        };
    },
}).name;
